var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_c('form',[_vm._t("SearchConditions",function(){return [_vm._v("[Slot SearchConditions Default]")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }